import { Cookies } from 'react-cookie';

import { TechnicianFormData, userOnClientCreationResponse } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const addOwnerForClient = async (owner: TechnicianFormData) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const response = await axiosInterceptor.post('clients/create-client-owner/', owner, {
    headers: {
      Authorization: token,
    },
  });
  return response.data as userOnClientCreationResponse;
};
